// extracted by mini-css-extract-plugin
export default {"Container":"marxentApp-module_Container_39Tsp"};